module.exports = __webpack_public_path__ + "img/programme_icon_moban@3x.b721d795.png";